import { Box, Stack, Button, Tooltip, Typography, Drawer, Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import {CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { useHistory } from 'react-router-dom';
import { CheckAccessFunc, formatDateAndTimeMeth2 } from '../../../Components/CommonFunctions/CommonFunctions'

export default function LabApprovalList() {
  const history = useHistory();
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [approvalList, setApprovalList] = useState([]);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [selectedTestName, setselectedTestName] = useState(null);
  const [selectedStatus, setselectedStatus] = useState(null);
  const [departmentFilter, setDepartmentFilte] = useState([]);

  useEffect(() => {
    getApprovalData()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getApprovalData = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.LAB_RESULT_APPROVER)
        .then((response) => {
          if (response.data.status === 'success') {
            setApprovalList(response.data.data || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const tableView = () => {
    const gridToolBar = () => {
      return (
        <Box>
          <Box sx={{ position: 'absolute', left: '0', top: '0', display: 'flex', flexDirection: 'row', alignItems: 'center', mt: '0.15vw', ml: '0.25vw' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              {/* <Autocomplete
                options={TestNameList}
                clearIcon={false}
                value={selectedTestName}
                getOptionLabel={(option) => option?.head_name}
                sx={{ ml: '0.5vw' }}
                onChange={(event, value) => {

                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Test Name"
                    variant="outlined"
                    size="small"
                    sx={{ width: "15vw" }}
                  />
                )}
              /> */}
            </Box>
          </Box>
          <Box>
            <CommonGridToolBarWithExtraFilter />
          </Box>
        </Box>
      )
    }

    approvalList?.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: "patient_name", flex: 0.30, headerName: "Patient Details", headerAlign: "left", align: "left",
        renderCell: (params) => (<Box component={'div'}>
          <CommonPatientDetails disablePhoto={true} data={params?.row} hideInsurance={true} />
        </Box>),
        valueGetter: (params) => {
          const Name = params.row?.patient_name || "";
          const Mobile = params.row?.patient_mobile || "";
          const UHID = params.row?.patient_account_number || "";
          return `${Name} ${Mobile} ${UHID}`;
        }
      },
      {
        field: 'department_name', headerName: 'Department Name', flex: 0.25,
        valueGetter: (params) => {
          const departments = params.row?.groups_or_tests
            ?.map(item => item.department_name)
            ?.filter(Boolean);

          return [...new Set(departments)].join(', ');
        },
        renderCell: (params) => {
          const departments = params.row?.groups_or_tests?.map(item => item.department_name)?.filter(Boolean);

          const uniqueDepartments = [...new Set(departments)];
          const deptText = uniqueDepartments.join(', ');

          return deptText ? (
            deptText.length > 30 ? (
              <Tooltip placement="top" title={deptText}>
                <Typography fontSize={'0.9vw'}>
                  {deptText.slice(0, 30) + '...'}
                </Typography>
              </Tooltip>
            ) : (
              <Typography fontSize={'0.9vw'}>
                {deptText}
              </Typography>
            )) : '-';
        }
      },
      // {
      //   field: 'test_sub', headerName: 'Test Submitted', flex: 0.20, align: 'center', headerAlign: 'center',
      //   renderCell: (params) => (<Box component={'div'}>{`${params.row?.completed_test} / ${params.row?.total_test}`}</Box>)
      // },
      {
        field: 'requester_name', headerName: 'Submitted By', flex: 0.25,
        valueGetter: (params) =>
          params.row?.groups_or_tests?.at(-1)?.requester_name || '',
        renderCell: (params) => {
          const groups = params.row.groups_or_tests || [];
          const submitted_by = groups[groups.length - 1]?.requester_name || '-';
          return (submitted_by ? submitted_by?.length > 25 ?
            <Tooltip placement="top" title={submitted_by}><Typography fontSize={'0.9vw'}>{submitted_by?.slice(0, 25) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{submitted_by}</Typography> : '-')
        }
      },
      {
        field: 'requested_at', headerName: 'Submitted On', flex: 0.25, align: 'center', headerAlign: 'center',
        valueGetter: (params) =>
          params.row?.groups_or_tests?.at(-1)?.requested_at || '',
        renderCell: (params) => {
          const groups = params.row.groups_or_tests || [];
          const submitted_on = groups[groups.length - 1]?.requested_at || '-';
          return (<Typography fontSize={'0.9vw'}>{formatDateAndTimeMeth2(submitted_on)}</Typography>)
        }
      },
      {
        field: 'action', headerName: 'Action', flex: 0.1, align: 'center', headerAlign: 'center',
        renderCell: (params) => (
          <Stack direction="row" alignItems="center" spacing={4}>
            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Button onClick={() => { history.push({ pathname: "/Results", state: { fromApproval: true, resultList: params.row } }) }} className='eMed_usrconf_btn'>
                <Box component={'img'} src={ImagePaths.Result.default} height={'2vw'} width={'2vw'} position={'relative'} />
              </Button>
            </Stack>
          </Stack>)
      }
    ]
    return (
      <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
        <DataGrid
          rows={approvalList}
          columns={columns}
          getRowId={(row) => row['sno']}
          page={page}
          pageSize={pageSize}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata'>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          onPageChange={(newPage) => { setpage(newPage) }}
          onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          disableSelectionOnClick
          loading={isloader}
        />
      </Box>
    )
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  return (
    <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
        {tableView()}
      </Box>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose}
        />
        : null}
    </Box>
  )
}